import type { HybridRestoreStep } from '@application/backup/HybridRestoreService';

/** Ordre d’affichage des étapes de restauration Hybride. */
export const HYBRID_RESTORE_STEPS: readonly HybridRestoreStep[] = [
  'download',
  'verify_hash',
  'decrypt',
  'check_content',
  'safety_backup',
  'import',
  'verify_integrity',
  'restore_files',
  'done',
] as const;

/** Libellés FR affichés pendant la progression (`aria-live`). */
export const HYBRID_RESTORE_STEP_LABELS: Readonly<Record<HybridRestoreStep, string>> = {
  download: 'Téléchargement…',
  verify_hash: 'Vérification de l’empreinte…',
  decrypt: 'Déchiffrement…',
  check_content: 'Contrôle du contenu…',
  safety_backup: 'Sauvegarde de sécurité…',
  import: 'Import des données…',
  verify_integrity: 'Vérification d’intégrité…',
  restore_files: 'Pièces jointes…',
  done: 'Terminé',
};

export function hybridRestoreStepLabel(step: HybridRestoreStep): string {
  return HYBRID_RESTORE_STEP_LABELS[step];
}
